import { cn } from '@/lib/utils';
import { Video } from 'lucide-react';

interface VideoPlaceholderProps {
  className?: string;
}

function VideoPlaceholder({ className }: VideoPlaceholderProps) {
  return (
    <div
      className={cn(
        'flex aspect-video h-auto w-40 items-center justify-center rounded border bg-gray-100 text-gray-400',
        className,
      )}
    >
      <div className="flex flex-col items-center gap-1">
        <Video className="h-6 w-6" />
        <span className="text-xs">No video</span>
      </div>
    </div>
  );
}

export default VideoPlaceholder;
